require('./stocksBuySellSummary.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { getInstitutionDescOfMarket } = require('utilities/micCodeHelper');

const {
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_LIMITED,
    CHARGE_ACCOUNT_PREFIX,
    TYPE_ETFS,
    TYPE_WARRANTS,
    BROKER_TYPE_STOCKS_NEW_DECIMALS,
    BROKER_TYPE_WARRANTS_SUMMARY_DECIMALS,
    BROKER_TYPE_ETFS_SUMMARY_DECIMALS
} = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class StocksBuySellSummary extends React.Component {
    constructor(props) {
        super(props);
    }

    getStockTypeText(orderTypeOption, productType) {
        let text;
        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
                text = formatText('broker-stocksSellOrderTypeOption1');
                break;
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                text = formatText('broker-stocksSellOrderTypeOption2');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                const { step1, maskLimitOrderType, productCurrency } = this.props;
                const currency = formatCurrency(productCurrency)
                let decimals;
                switch(productType) {
                    case TYPE_ETFS://3
                        decimals = BROKER_TYPE_ETFS_SUMMARY_DECIMALS;
                        break;
                    case TYPE_WARRANTS://2
                        decimals = BROKER_TYPE_WARRANTS_SUMMARY_DECIMALS;
                        break;
                    default://4
                        decimals = BROKER_TYPE_STOCKS_NEW_DECIMALS;
                        break;
                }
                const limitValueText = formatAmount(step1.get('orderTypeValue'), undefined, decimals).toString();
                if (!maskLimitOrderType) {
                    text = formatText('broker-stocksSellOrderTypeOption3', [limitValueText, currency]);
                }
                else {
                    text = limitValueText;
                }
                break;
        }
        return text;
    }

    getStockTypeTitle(orderTypeOption) {
        let text;
        switch (orderTypeOption) {
            case BROKER_ORDER_TYPE_TO_MARKET:
            case BROKER_ORDER_TYPE_FOR_THE_BEST:
                text = formatText('broker-stocksBuySellSummaryStockTypeTitle');
                break;
            case BROKER_ORDER_TYPE_LIMITED:
                const { maskLimitOrderType } = this.props;
                if (!maskLimitOrderType) {
                    text = formatText('broker-stocksBuySellSummaryStockTypeTitle');
                } else {
                    text = formatText('broker-stocksBuySellSummaryStockTypeMaskedTitle');
                }
                break;
        }
        return text;
    }

    buildValidityDateBlock(uppercaseTitle) {
        const { step1, step1Real } = this.props;
        let validityDate;

        if (step1 && step1.get('validityDate')) {
            validityDate = step1.get('validityDate');
        }

        if (step1Real && step1Real.get('validityDate')) {
            validityDate = step1Real.get('validityDate');
        }

        const formattedValidityDate = validityDate
            ? validityDate.format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))
            : '-';

        return (
            <OKInformativeListItem
                title={formatText('broker-stocksBuySellSummaryVilidityTermTitle')}
                bodyText={formattedValidityDate}
                isUppercaseTitle={uppercaseTitle}
                className="stocks-buy-sell-summary__stock-title"
            />
        );
    }

    buildOrderTypeBlock(orderTypeOption, productType) {

        const stockTypeText = this.getStockTypeText(orderTypeOption, productType);
        const stockTypeTitle = this.getStockTypeTitle(orderTypeOption);
        const block = (
            <OKInformativeListItem
                title={stockTypeTitle}
                bodyText={stockTypeText}
                isUppercaseTitle={true}
                className="stocks-buy-sell-summary__stock-title"
            />
        );

        return block;
    }

    buildStockExchangeBlock(productIso) {
        const institutionDesc = getInstitutionDescOfMarket(productIso);
        return (
            <div className="stocks-buy-sell-summary__stock-container-info stocks-buy-sell-summary__stock-container-info--name">
                {institutionDesc}
            </div>
        );
    }

    render() {
        const {
            productName,
            stockContract,
            stockDescription,
            step1,
            step2,
            modifier,
            columns,
            productIso,
            productType,
            titlesQuantityTitle
        } = this.props;
        const stockExchangeBlock = this.buildStockExchangeBlock(productIso);
        const orderTypeOption = step1.get('orderTypeOption');
        const uppercaseTitle = true;
        const orderTypeBlock = this.buildOrderTypeBlock(orderTypeOption, productType);
        let stockOperationTitle = formatText('broker-stocksBuySellSummaryBuyStockTitle', [
            productName
        ]);
        let formattedEmittedDateTime;
        let emittedDateTimeBlock;
        let validityDateBlock;

        const balanceLabel = formatText('broker-stocksBuySellSummaryBalanceTitle');
        const walletBalance = stockContract.getIn(['associatedAccountBalance', 'amount']);
        const walletCurrency = stockContract.getIn(['associatedAccountBalance', 'currency']);
        const titlesQuantity = formatText(`broker-${titlesQuantityTitle}`);
        const bodyWordBreak = productType === TYPE_WARRANTS ? false : true;

        if (
            modifier === BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER ||
            modifier === BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER ||
            step1.get('validityDate')
        ) {
            validityDateBlock = this.buildValidityDateBlock(uppercaseTitle);
        }

        if (modifier === BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER) {
            stockOperationTitle = formatText('broker-stocksBuySellSummarySellStockTitle', [
                productName
            ]);
        }

        if (step2 && step2.get('isEmitted')) {
            formattedEmittedDateTime = step2
                .get('emittedDateTime')
                .format(formatText('datePickerCustom-dateTimeFormat'));
            emittedDateTimeBlock = (
                <div>
                    <div className="stocks-buy-sell-summary__emitted-date-time-title">
                        <FormattedText
                            className="stocks-buy-sell-summary__emitted-date-time-text"
                            value="broker-stocksBuySellSummaryEmitDateTimeTitle"
                        />
                        <OKTooltip
                            content="broker-broker_DateAndTimeToolTip"
                            offset={[0, -15]}
                        />
                    </div>
                    <div className="stocks-buy-sell-summary__emitted-date-time-body-text">
                        {formattedEmittedDateTime}
                    </div>
                </div>
            );
        }

        return (
            <section className="stocks-buy-sell-summary__info-section row">
                <div className={`col-lg-${columns}`}>
                    <div className="stocks-buy-sell-summary__titles-container-left">
                        <OKInformativeList>
                            <OKInformativeListItem
                                title={stockOperationTitle}
                                bodyText={stockDescription}
                                columns={1}
                                isUppercaseTitle={uppercaseTitle}
                                className="stocks-buy-sell-summary__stock-title"
                                bodyWordBreak={bodyWordBreak}
                            >
                                {stockExchangeBlock}
                            </OKInformativeListItem>

                            <OKInformativeListItem
                                title={formatText('broker-stocksBuySellSummaryStockContractTitle')}
                                bodyText={stockContract.get('walletAccountType')}
                                columns={1}
                                isUppercaseTitle={uppercaseTitle}
                                className="stocks-buy-sell-summary__stock-title"
                            >
                                <span className="stocks-buy-sell-summary__stock-container-info stocks-buy-sell-summary__stock-container-info--account">
                                    {CHARGE_ACCOUNT_PREFIX}
                                    {stockContract.get('controlDigit')}
                                    {stockContract.get('productNumber')}
                                    {stockContract.get('walletNumber')}
                                </span>
                                <FormattedText
                                    value="broker-stocksBuySellSummaryFirstTitularText"
                                    injectedStrings={[stockContract.get('firstTitular')]}
                                    className="stocks-buy-sell-summary__stock-container-info stocks-buy-sell-summary__stock-container-info--first-titular"
                                />
                                <FormattedText
                                    value="broker-stocksBuySellSummaryAssociatedAccountText"
                                    injectedStrings={[stockContract.get('associatedAccountAlias')]}
                                    className="stocks-buy-sell-summary__stock-container-info"
                                />
                                <span className="stocks-buy-sell-summary__stock-container-info">
                                    {stockContract.get('associatedAccount')} ({balanceLabel}{' '}
                                    {formatAmount(walletBalance)} {formatCurrency(walletCurrency)})
                                </span>
                            </OKInformativeListItem>
                        </OKInformativeList>
                    </div>
                </div>

                <div className={`col-lg-${columns}`}>
                    <div className="stocks-buy-sell-summary__titles-container-right">
                        <OKInformativeList>
                            <OKInformativeListItem
                                title={titlesQuantity}
                                bodyText={step1.get('titleQuantity').toString()}
                                isUppercaseTitle={uppercaseTitle}
                                className="stocks-buy-sell-summary__stock-title"
                            />
                            {orderTypeBlock}
                            {validityDateBlock}
                            {emittedDateTimeBlock}
                        </OKInformativeList>
                    </div>
                </div>
            </section>
        );
    }
}

StocksBuySellSummary.propTypes = {
    productCurrency:PropTypes.string,
    productName: PropTypes.string.isRequired,
    stockDescription: PropTypes.string.isRequired,
    productIso: PropTypes.string,
    productType: PropTypes.string,
    stockContract: PropTypes.object.isRequired,
    step1Real: PropTypes.object,
    step1: PropTypes.object.isRequired,
    step2: PropTypes.object,
    columns: PropTypes.number.isRequired,
    modifier: PropTypes.oneOf([
        BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
        BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER
    ]),
    maskLimitOrderType: PropTypes.bool.isRequired,
    titlesQuantityTitle: PropTypes.string
};

StocksBuySellSummary.defaultProps = {
    columns: 5,
    maskLimitOrderType: false,
    productIso: '',
    productType: '',
    titlesQuantityTitle: 'stocksBuySellSummaryTitlesQuantityTitle'
};

module.exports = StocksBuySellSummary;
